<template lang="pug">
vm-row(vm-w="12")
  vm-row(vm-align="left" vm-type="flex" vm-w=12)
    vm-checkbox(class="check-box-iva" v-model='checkIvaMxn') {{ $t('projects.show_iva') }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total")' :textValue='project.total_oc_mxn' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice")' :textValue='totalInvoicedAmountMxn' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid")' :textValue='totalPaymentsAmountMxn' color="green" :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='textBalancePaid' :textValue='totalPendingPayableMxn' color="primary" :currency="'MXN'")
  vm-row(v-if="checkIvaMxn" vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_without_iva")' :textValue='project.subtotal_oc_mxn' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice_without_iva")' :textValue='totalInvoicedAmountMxnWithoutIva' :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid_without_iva")' :textValue='totalPaymentsAmountMxnWithoutIva' color="green" :currency="'MXN'")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='textBalancePaidWithoutIva' :textValue='totalPendingPayableMxnWithoutIva' color="primary" :currency="'MXN'")
  vm-row(class="section-usd" vm-align="left" vm-type="flex" vm-w=12)
    vm-checkbox(class="check-box-iva" v-model='checkIvaUsd') {{ $t('projects.show_iva') }}
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total")' :textValue='project.total_oc_usd')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice")' :textValue='totalInvoicedAmountUsd')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid")' :textValue='totalPaymentsAmountUsd' color="green")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='textBalancePaid' :textValue='totalPendingPayableUsd' color="primary")
  vm-row(v-if="checkIvaUsd" vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=12)
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_without_iva")' :textValue='project.subtotal_oc_usd')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_invoice_without_iva")' :textValue='totalInvoicedAmountUsdWithoutIva')
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='$t("projects.total_amount_paid_without_iva")' :textValue='totalPaymentsAmountUsdWithoutIva' color="green")
    vm-col(class="section-money" vm-align="center" vm-w=3)
      MoneyCard(:title='textBalancePaidWithoutIva' :textValue='totalPendingPayableUsdWithoutIva' color="primary")
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=6)
    vm-col(class="section-title" vm-align="center" vm-w=12 vm-type="flex" vm-justify="center")
      h2 {{ $t('strings.invoices') }}: {{dataInvoices.length}}
    vm-col(class="section-money" vm-align="center" vm-w=12)
      ProjectTablesDashboard(typeSelect="selectInvoice" @selectInvoice='selectInvoice' :data='dataInvoices', :columns='columns', :status='status')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-around" vm-w=6)
    vm-col(class="section-title" vm-align="center" vm-w=12 vm-type="flex" vm-justify="center")
      h2 {{ $t('strings.payments') }}: {{dataPayments.length}}
    vm-col(class="section-money" vm-align="center" vm-w=12)
      ProjectTablesDashboard(:data='dataPayments', :columns='columns2', :status='status')
</template>
<script>
import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('ProjectsDashboard')
const TitleCard = () => import('@/components/aditionals/TitleCard.vue')
const MoneyCard = () => import('@/components/aditionals/MoneyCard.vue')
const ProjectTablesDashboard = () => import('@/components/aditionals/ProjectTablesDashboard.vue')

export default {
  name: 'CustomerInvoicesDashboard',
  components: {
    TitleCard,
    MoneyCard,
    ProjectTablesDashboard
  },
  mixins: [ViewMixinMaster1],
  data: () => ({
    columns: ['id', 'subtotal', 'tax_amount', 'total', 'currency', 'user_display', 'created_at'],
    columns2: ['id', 'subtotal', 'tax_amount', 'total', 'currency_payment', 'type', 'user_display', 'date'],
    status: [
      {
        value: 'paid',
        color: 'success'
      },
      {
        value: 'partially_paid',
        color: 'primary'
      },
      {
        value: 'pending',
        color: 'warning'
      }
    ],
    selectedInvoiceId: '',
    selectedInvoiceMxn: {},
    selectedPaymentMxn: {},
    selectedInvoiceUsd: {},
    selectedPaymentUsd: {},
    textBalancePaid: 'Saldo por facturar',
    textBalancePaidWithoutIva: 'Saldo por facturar sin Iva',
    checkIvaMxn: false,
    checkIvaUsd: false
  }),
  computed: {
    ...mapGetters(['project', 'invoicesPurchaseOrderUsd', 'invoicesPurchaseOrderMxn', 'paymentsMxn', 'paymentsUsd', 'invoicesPurchaseOrder', 'payments']),
    dataInvoices () {
      return this.invoicesPurchaseOrder && !this.selectedInvoiceId ? this.invoicesPurchaseOrder : this.invoicesPurchaseOrder.filter(e => { return e.id === this.selectedInvoiceId })
    },
    dataPayments () {
      return this.payments && !this.selectedInvoiceId ? this.payments : this.payments.filter(e => { return e.invoice_id === this.selectedInvoiceId })
    },
    totalInvoicedAmountUsd () {
      return this.selectedInvoiceId ? this.selectedInvoiceUsd.reduce((acc, crr) => { return +acc + +crr.total }, 0) : this.invoicedAmountUsd
    },
    totalInvoicedAmountMxn () {
      return this.selectedInvoiceId ? this.selectedInvoiceMxn.reduce((acc, crr) => { return +acc + +crr.total }, 0) : this.InvoicedAmountMxn
    },
    totalInvoicedAmountUsdWithoutIva () {
      return this.selectedInvoiceId ? this.selectedInvoiceUsd.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : this.invoicedAmountUsdWithoutIva
    },

    totalInvoicedAmountMxnWithoutIva () {
      return this.selectedInvoiceId ? this.selectedInvoiceMxn.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : this.InvoicedAmountMxnWithoutIva
    },

    totalPaymentsAmountUsd () {
      return this.selectedInvoiceId && this.selectedPaymentUsd ? this.selectedPaymentUsd.reduce((acc, crr) => { return +acc + +crr.total }, 0) : this.paymentsAmountUsd
    },
    totalPaymentsAmountMxn () {
      return this.selectedInvoiceId && this.selectedPaymentMxn ? this.selectedPaymentMxn.reduce((acc, crr) => { return +acc + +crr.total }, 0) : this.paymentsAmountMxn
    },

    totalPaymentsAmountUsdWithoutIva () {
      return this.selectedInvoiceId && this.selectedPaymentUsd ? this.selectedPaymentUsd.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : this.paymentsAmountUsdWithoutIva
    },
    totalPaymentsAmountMxnWithoutIva () {
      return this.selectedInvoiceId && this.selectedPaymentMxn ? this.selectedPaymentMxn.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : this.paymentsAmountMxnWithoutIva
    },
    totalPendingPayableUsd () {
      return this.selectedInvoiceId && this.selectedPaymentUsd ? parseFloat(this.totalInvoicedAmountUsd) - +parseFloat(this.totalPaymentsAmountUsd) : this.pendingPayableUsd
    },
    totalPendingPayableMxn () {
      return this.selectedInvoiceId && this.selectedPaymentMxn ? parseFloat(this.totalInvoicedAmountMxn) - +parseFloat(this.totalPaymentsAmountMxn) : this.pendingPayableMxn
    },
    totalPendingPayableUsdWithoutIva () {
      return this.selectedInvoiceId && this.selectedPaymentUsd ? parseFloat(this.totalInvoicedAmountUsdWithoutIva) - +parseFloat(this.totalPaymentsAmountUsdWithoutIva) : this.pendingPayableUsdWithoutIva
    },
    totalPendingPayableMxnWithoutIva () {
      return this.selectedInvoiceId && this.selectedPaymentMxn ? parseFloat(this.totalInvoicedAmountMxnWithoutIva) - +parseFloat(this.totalPaymentsAmountMxnWithoutIva) : this.pendingPayableMxnWithoutIva
    },
    invoicedAmountUsd () {
      return this.invoicesPurchaseOrderUsd ? this.invoicesPurchaseOrderUsd.reduce((acc, crr) => { return +acc + +crr.total }, 0) : 0
    },
    InvoicedAmountMxn () {
      return this.invoicesPurchaseOrderMxn ? this.invoicesPurchaseOrderMxn.reduce((acc, crr) => { return +acc + +crr.total }, 0) : 0
    },
    invoicedAmountUsdWithoutIva () {
      return this.invoicesPurchaseOrderUsd ? this.invoicesPurchaseOrderUsd.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : 0
    },
    InvoicedAmountMxnWithoutIva () {
      return this.invoicesPurchaseOrderMxn ? this.invoicesPurchaseOrderMxn.reduce((acc, crr) => { return +acc + +crr.subtotal }, 0) : 0
    },
    paymentsAmountUsd () {
      return this.paymentsUsd ? parseFloat(this.paymentsUsd.reduce((acc, crr) => acc + +crr.total, 0)) : 0
    },
    paymentsAmountMxn () {
      return this.paymentsMxn ? parseFloat(this.paymentsMxn.reduce((acc, crr) => acc + +crr.total, 0)) : 0
    },
    paymentsAmountUsdWithoutIva () {
      return this.paymentsUsd ? parseFloat(this.paymentsUsd.reduce((acc, crr) => acc + +crr.subtotal, 0)) : 0
    },
    paymentsAmountMxnWithoutIva () {
      return this.paymentsMxn ? parseFloat(this.paymentsMxn.reduce((acc, crr) => acc + +crr.subtotal, 0)) : 0
    },
    pendingPayableUsd () {
      return parseFloat(this.project.total_oc_usd) - parseFloat(this.totalInvoicedAmountUsd)
    },
    pendingPayableMxn () {
      return parseFloat(this.project.total_oc_mxn) - parseFloat(this.totalInvoicedAmountMxn)
    },
    pendingPayableUsdWithoutIva () {
      return parseFloat(this.project.subtotal_oc_usd) - parseFloat(this.totalInvoicedAmountUsdWithoutIva)
    },
    pendingPayableMxnWithoutIva () {
      return parseFloat(this.project.subtotal_oc_mxn) - parseFloat(this.totalInvoicedAmountMxnWithoutIva)
    }
  },
  watch: {
    selectedInvoiceId (selectedInvoiceId) {
      this.textBalancePaid = selectedInvoiceId ? this.textBalancePaid = 'Saldo por pagar' : 'Saldo por facturar'
      this.textBalancePaidWithoutIva = selectedInvoiceId ? this.textBalancePaidWithoutIva = 'Saldo por pagar sin Iva' : 'Saldo por facturar sin Iva'
    }
  },
  methods: {
    ...mapActions([]),
    selectInvoice (data) {
      if (this.selectedInvoiceId === data.id) {
        this.selectedInvoiceId = ''
        this.selectedInvoiceMxn = this.invoicesPurchaseOrderMxn
        this.selectedPaymentMxn = this.paymentsMxn
        this.selectedInvoiceUsd = this.invoicesPurchaseOrderUsd
        this.selectedPaymentUsd = this.paymentsUsd
      } else {
        this.selectedInvoiceId = data.id
        this.selectedInvoiceMxn = this.invoicesPurchaseOrderMxn.filter(i => i.id === this.selectedInvoiceId)
        this.selectedPaymentMxn = this.paymentsMxn.filter(i => i.invoice_id === this.selectedInvoiceId)
        this.selectedInvoiceUsd = this.invoicesPurchaseOrderUsd.filter(i => i.id === this.selectedInvoiceId)
        this.selectedPaymentUsd = this.paymentsUsd.filter(i => i.invoice_id === this.selectedInvoiceId)
      }
    }
  }
}
</script>
<style lang="scss">
.section-money {
  padding: 5px;
  height: 100%;
}
.section-title {
  margin: 10px 15px !important;
}
.section-usd {
  margin-top: 10px;
  border-top: 1px solid rgba(var(--gray), 1);
}
.check-box-iva {
  margin-top: 10px;
}
</style>
